import ModelViewController from './ModelViewController';

export default ModelViewController;
